import { render } from "./ContactViewCategories.vue?vue&type=template&id=28d894c9"
import script from "./ContactViewCategories.vue?vue&type=script&lang=js"
export * from "./ContactViewCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__